import { __require as requireFunctionUncurryThis } from './node_modules-core-js-internals-function-uncurry-this.js';
import { __require as requireFails } from './node_modules-core-js-internals-fails.js';
import { __require as requireClassofRaw } from './node_modules-core-js-internals-classof-raw.js';

var indexedObject;
var hasRequiredIndexedObject;

function requireIndexedObject () {
	if (hasRequiredIndexedObject) return indexedObject;
	hasRequiredIndexedObject = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var fails = requireFails();
	var classof = requireClassofRaw();

	var $Object = Object;
	var split = uncurryThis(''.split);

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	indexedObject = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof(it) === 'String' ? split(it, '') : $Object(it);
	} : $Object;
	return indexedObject;
}

export { requireIndexedObject as __require };
//# sourceMappingURL=node_modules-core-js-internals-indexed-object.js.map
